var exports = {
  "k": "x804f0401--14b1e7--container",
};

module.exports = exports;
